export class InternalAuditExecutionItemDTO {
  entityType!: number;

  entityId!: number;

  code?: string;

  name?: string;

  outcome!: number;

  conclusion?: string;

  assessedState?: number;

  writeBackState?: number;

  assessedById?: string;

  assessedOn?: string;

  // exact planned start; date selects the audit day and time stores its position within that day
  plannedOn?: string;

  taskId?: number;

  taskName?: string;

  // the procedure the task was built from; absent without a task or when the library lost it
  procedureTaskId?: number;

  procedureName?: string;

  taskStateId?: number;

  taskCompleted!: boolean;

  assigneeId?: string;

  proposedTemplateTaskId?: number;

  proposedTemplateTaskName?: string;

  proposedUserId?: string;

  proposalSource!: number;

  needsFinding!: boolean;
}

export class InternalAuditProcedureDTO {
  taskId!: number;

  name?: string;
}

export default class InternalAuditExecutionDTO {
  internalAuditId!: number;

  items!: InternalAuditExecutionItemDTO[];

  procedures!: InternalAuditProcedureDTO[];
}

export class InternalAuditScopeItemKeyDTO {
  entityType!: number;

  entityId!: number;
}

export class InternalAuditExecutionAssignDTO {
  items!: InternalAuditScopeItemKeyDTO[];

  userId!: string;

  // overrides the per-item proposal for every item in the call; null uses each item's own proposal
  templateTaskId?: number;
}

export class InternalAuditExecutionItemsDTO {
  items!: InternalAuditScopeItemKeyDTO[];

  // whether the findings raised from the execution tasks being deleted must go too. Left out = keep
  // them: such a finding survives as an ordinary task, it only stops being a finding of this audit
  deleteFindings?: boolean;
}

// How much follow-up work is about to lose its tie to the audit: the answer of the findings precheck
export class InternalAuditFindingsPrecheckDTO {
  taskCount!: number;

  findingCount!: number;
}

export class InternalAuditExecutionPlanDTO {
  items!: InternalAuditScopeItemKeyDTO[];

  // the audit day, as a date without time; undefined clears the planning (back to the default day)
  plannedOn?: string;
}

export class InternalAuditExecutionOrderItemDTO extends InternalAuditScopeItemKeyDTO {
  plannedDay!: string;
}

export class InternalAuditExecutionReorderDTO {
  items!: InternalAuditExecutionOrderItemDTO[];
}

// One stop on the auditee's walk through their own work: the item to audit and the task that audits
// it. The unit is the PAIR - one task can audit several scope items, and stepping per task would skip
// straight past all but the first of them.
export class InternalAuditTaskNavigationStopDTO {
  entityType!: number;

  entityId!: number;

  taskId!: number;
}

export class InternalAuditTaskNavigationDTO {
  internalAuditId!: number;

  stops!: InternalAuditTaskNavigationStopDTO[];
}

export class InternalAuditScopeAssessmentDTO {
  internalAuditId!: number;

  auditName?: string;

  auditStartDate?: string;

  auditEndDate?: string;

  entityType!: number;

  entityId!: number;

  outcome!: number;

  conclusion?: string;

  assessedState?: number;

  writeBackState?: number;

  assessedById?: string;

  assessedOn?: string;
}

export class InternalAuditTaskExecutionItemDTO {
  entityType!: number;

  entityId!: number;

  code?: string;

  name?: string;

  outcome!: number;

  conclusion?: string;

  assessedById?: string;

  assessedOn?: string;

  previous?: InternalAuditScopeAssessmentDTO;
}

export class InternalAuditTaskExecutionDTO {
  internalAuditId!: number;

  auditName?: string;

  auditStatus!: number;

  canEdit!: boolean;

  items!: InternalAuditTaskExecutionItemDTO[];
}

export class InternalAuditTaskResultDTO {
  outcome!: number;

  conclusion?: string;

  // The result was filled by adopting the AI audit proposal ("Take over result"); recorded in the
  // audit trail so the record shows where the assessment started.
  fromAiAudit?: boolean;
}

export class InternalAuditProcedureSuggestionDTO {
  entityType!: number;

  entityId!: number;

  templateTaskId!: number;

  reason?: string;
}
